//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/TaggedObject.js";
let d=[[],[[["num_source_entities_to_map"],"GetSourcePartEntitiesToMap",{R_:{sourceEntitiesToMap:"TaggedObject[]"}},0,0],[["num_mirror_entities_to_map"],"GetMirrorPartEntitiesToMap",{R_:{mirrorEntitiesToMap:"TaggedObject[]"}},0,0],[["num_mapped_source_entities"],"GetMappedSourcePartEntities",{R_:{mappedSourceEntities:"TaggedObject[]"}},0,0],[["num_mapped_mirror_entities"],"GetMappedMirrorPartEntities",{R_:{mappedMirrorEntities:"TaggedObject[]"}},0,0],[["sourceEntity","mirrorEntity"],"AddToMap",{},2,0]],[]];
SPLM.LinkedMirrorPartEntityMapData = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.LinkedMirrorPartEntityMapData";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;